export const getPathName = () => {
  const path = window.location.pathname.replace(/\/+$/, '');
  return path.startsWith('/') ? path.slice(1) : path;
};

export const validateRepeatedName = (names: string[], name: string) =>
  names?.some((n) => n.trim().toLowerCase() === name?.trim()?.toLowerCase());

export const getRealmIdFromURL = (url: { pathname: string }) =>
  url.pathname.includes('/realm/') &&
  url.pathname.split('/realm/')[1]?.split('/')[0];

export const getRealmPathFromURL = (url: { pathname: string }) =>
  url.pathname.includes('/realm/') &&
  url.pathname.split('/realm/')[1]?.split('/')[1];
